import * as React from 'react'

export const AmpCarousel = (props) => {
  const { children, className } = props
  return (
    <React.Fragment>
      <amp-carousel {...props} className={className}>
        {children}
      </amp-carousel>
    </React.Fragment>
  )
}

export default AmpCarousel
